import { errorService, t } from "app/utils";
import { IMAGE_TYPE } from "../../components/stories/video-studio/utils/constants";

const downloadFile = async (url: string, mediaType: string) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const reader = new FileReader();

    reader.onloadend = () => {
      const element = document.createElement("a");
      if (typeof reader.result === "string") {
        const timestamp = Date.now();
        element.href = reader.result;
        element.download = mediaType === IMAGE_TYPE ? `${timestamp}_photo.jpg` : `${timestamp}_video.mp4`;
        document.body.appendChild(element);
        element.click();
      }

      setTimeout(() => {
        document.body.removeChild(element);
      }, 200);
    };
    reader.readAsDataURL(blob);
  } catch (error) {
    errorService.error(error);
  }
};

export default downloadFile;
